// GENERATED FILE - DO NOT MODIFY
export enum InventoryProjectTransferStatus {
    Active = "0",
    Complete = "1",
    Close = "C",
}

export let nameof = "InventoryProjectTransferStatus";
